export default __webpack_public_path__ + "static/media/swiss-dish-washer-lemon.8939e878.jpg";